import request from "@/utils/request";


export function getTodoList(params) {
  return request({
    url: "/todolist/gettodolist",
    method: "get",
    params: params
  });
}


export function updateTodoList(params) {
  return request({
    url: "/todolist/updatetodolist",
    method: "get",
    params: params
  });
}
